"use client";
import dynamic from "next/dynamic";
import LoadingPage from "./LoadingPage";
import CustomWindow from "./CustomWindow";

const ScrollTopButton = dynamic(() => import("./ScrollTopButton"), {
  ssr: !!false,
});

const PopupCoupons = dynamic(() => import("./PopupCoupons"), { ssr: !!false });
const PopupMessages = dynamic(() => import("./PopupMessages"), { ssr: !!false });
const GameModal = dynamic(() => import("./GameModal"), { ssr: !!false });
const FreeSpinModal = dynamic(() => import("./FreeSpinModal"), { ssr: !!false });
import { useContext } from "react";
import { AppContext } from "@/src/context/AppContext";
import { GameContext } from "@/src/context/GameContext";

export default function MainComponent({ children }) {
  const {
    pageLoader,
    link,
    openModal,
    setOpenModal,
    setLink,
    isCouponOpen,
    setIsCouponOpen,
    activeCoupon,
  } = useContext(AppContext);
  const { setSelectedGame } = useContext(GameContext);

  const closeModal = () => {
    setOpenModal(false);
    setLink(null);
    Tawk_API.showWidget();
  };

  const closeCouponModal = () => {
    Tawk_API.showWidget();
    setIsCouponOpen(false);
  };
  return (
    <main id="root">
      <CustomWindow
        iframeUrl={link}
        isIframeVisible={openModal}
        setIsIframeVisible={closeModal}
        setSelectedGame={setSelectedGame}
      />
      <LoadingPage loader={pageLoader} />

      {children}

      <ScrollTopButton />
      <PopupCoupons
        isOpen={isCouponOpen}
        activeCoupon={activeCoupon}
        onClose={closeCouponModal}
      />
      <PopupMessages />
      <GameModal />
      <FreeSpinModal />
    </main>
  );
}
